export default __webpack_public_path__ + "2655d0dfde62992261131ef73645f9c9.png";